import { render, staticRenderFns } from "./Gvd.vue?vue&type=template&id=ac2548b2&scoped=true"
import script from "./Gvd.vue?vue&type=script&lang=ts"
export * from "./Gvd.vue?vue&type=script&lang=ts"
import style0 from "./Gvd.vue?vue&type=style&index=0&id=ac2548b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2548b2",
  null
  
)

export default component.exports